import ACTIONS from "../../constatnts"
import { ImageInfo } from "./types/parts"

export const addImagesToPart = (part_id: string, imageInfoArray: ImageInfo[], scaleFactor: number, t: any, isGrid: boolean) =>
  isGrid ? (dispatch: any, getState: any) =>
    dispatch({
      type: ACTIONS.ADD_IMAGES_TO_PART,
      part_id,
      imageInfoArray,
      scaleFactor,
      t,
      V: getState().fabric.segmentInFocus,
      isGrid: true
    }) : ({
      type: ACTIONS.ADD_IMAGES_TO_PART,
      part_id,
      imageInfoArray,
      scaleFactor,
      t,
    })